module.exports = "<div class=\"message alert\">\n  <div class=\"icon\">\n    <span>Priority</span>\n    <img title=\"Critical\" alt=\"icon\" src=\"./assets/img/icon_danger.svg\" style=\"width: 24px; height: 24px\" />\n  </div>\n  <div class=\"info-content\">\n    <p class=\"title\">{{ alarm.title }}</p>\n    <p class=\"date\">{{ alarm.timestamp | date: 'yyyy-MM-dd HH:mm' }}</p>\n    <p class=\"comments\">{{ alarm.message }}</p>\n  </div>\n  <div class=\"info-edit\">\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/alarms/message/park-alarms-item.html
// module id = ./src/app/dashboard/parks/park/alarms/message/park-alarms-item.html
// module chunks = main